import { render, staticRenderFns } from "./cSkillWorkspace.vue?vue&type=template&id=492db962&scoped=true"
import script from "./cSkillWorkspace.vue?vue&type=script&setup=true&lang=js"
export * from "./cSkillWorkspace.vue?vue&type=script&setup=true&lang=js"
import style0 from "./cSkillWorkspace.vue?vue&type=style&index=0&id=492db962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492db962",
  null
  
)

export default component.exports